<script>
import Dropdown from '@/components/Fields/dropdown';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';

export default {
  functional: true,
  render(h, ctx) {
    const options = ctx.props.menuItems.map(item => ({
      name: `<i class="fa-regular ${item.icon}"></i> ${item.text}
        ${item.isNew ? '<span class="ml-1 text-xs font-bold text-primary-green">NEW</span>' : ''}`,
      slug: item.link.replace(/^\/|\/$/g, ''), // trim leading and trailing slashes
    }));
    const trimSlashes = inputString => inputString.replace(/^\/|\/$/g, '');
    const trailingSlashPath = trimSlashes(ctx.parent.$route.path);
    return (
            <div class="lg:hidden">
                <Dropdown
                    options={options}
                    prependedPlaceholder=" "
                    value={trailingSlashPath}
                    autoScroll={true}
                    onInput={(val) => {
                      // eslint-disable-next-line max-len
                      const eventName = ctx.props.menuItems.filter(item => trimSlashes(item.link) === val)[0].name;
                      eventTracker(
                        analyticsEvents.myAccountArea.menuItemChosen, { menu: 'my account', item: eventName },
                      );
                      window.location.href = `/${val}/`;
                    }}
                />
            </div>
    );
  },
};
</script>

<style scoped>
.text-\[\#4d4d4d\] {
    color: #4d4d4d;
}
>>> .text-\[\#827bff\] {
    color: #827bff;
}
>>> .dropdown {
    @apply text-[#4d4d4d];
}
>>> .dropdown .ellipsis i {
    @apply mr-1 font-bold;
}
>>> .dropdown-options li i {
    @apply mr-2;
}
</style>
